// extracted by mini-css-extract-plugin
module.exports = {"modelWrap":"video-model_modelWrap_1i3N1","modelBox":"video-model_modelBox_XWNan","header":"video-model_header_1I1FL","main":"video-model_main_3fThg"};